import React, { useEffect, useState, useRef, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

// Components
//import Max2Media from '../object/media';
import AjaxController from '../system/ajaxController';

// Redux slices
import { setActivePage, setUser, setToken } from '../../appSlice';

/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

// SemanticUI components
import { Segment, Icon, Label, Header, HeaderContent, Form, FormGroup, FormInput, FormField, Button } from 'semantic-ui-react';

// Style
import './media.css';



/**
 * 
 * @returns 
 */
const Max2PageMedia = () => {
  // lockaler State
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadad, setIsLoaded] = useState(false);
  const [searchFilter, setSearchFilter] = useState('');
  const [pagination, setPagination] = useState(0);
  const [sorting, setSorting] = useState('name_asc');

  // Globaler State
  const dispatch = useDispatch();
  const backendUrl    = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

  
  const isFetching = useRef(false); // Ref, um mehrfachen Request zu verhindern

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();


  /**
   * Sends the filter request 
   * http://localhost:8080/filter/W29iamVjdCBPYmplY3Rd
   * 
   * @param {string} backendUrl 
   * @param {object} filter 
   * @param {object} pagination 
   * @param {object} sorting 
   */
  const handleFilterClick = (backendUrl, filter, pagination, sorting) => {
    
    // encode filter params object
    const query = {
      filter: filter, 
      pagination: pagination,
      sorting: sorting
    }
    
    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });
    
    
    // search for hotels
    const fetchData = async () => {
      try {

        // show loading animation
        setIsLoading(true);

        // send count request
        const count = await api.get('/count/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

        // send filter request
        const response = await api.get('/filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
        
        // hide loading animation
        setIsLoading(false);

        // display results
        //dispatch(setResult({result: response, numberOfRecordsTotal: count}))

      } catch (err) {
        //setError(err.message);
        console.error(err.message)
      }
    };

    fetchData();
  }
  

  // Load object data on first render
  useEffect(() => {
    /*const api = new AjaxController(backendUrl, () => {
          dispatch(setActivePage('START'));
          dispatch(setUser(null));
          dispatch(setToken(null));
        });
    
    const fetchData = async () => {
      if (isFetching.current) return; // Überspringe, falls bereits ein Request läuft
      isFetching.current = true;

      try {
        const response = await api.get('/images/');

        // display results
        setIsLoading(false);
        setIsLoaded(true);
        if (typeof response.object === 'object') {
          //dispatch(setObjectData(response.object));
        }
        if (typeof response.meta === 'object') {
          //dispatch(setMetaData(response.meta));
        }
      } catch (err) {
        //setError(err.message);
        console.error(err.message)
      }
    };
    
    fetchData();*/

    setIsLoaded(true);

  }, [backendUrl, dispatch, isLoading]);


  // loading animation
  if (!isLoadad) {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Header as='h2' textAlign='center'>
          <Icon loading name='spinner' />
          <HeaderContent>
            Daten werden geladen
          </HeaderContent>
        </Header>
      </Segment>
    )
  }

  return (
    <>
    
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Label circular style={{marginBottom: '20px', background: 'transparent'}}><span style={{fontSize: '1.4em', margin: '10px'}}>Medien</span></Label>
        
        <Form>
          <FormGroup>
            <FormInput 
              fluid 
              label = 'Suchtext' 
              placeholder = 'Suchtext eingeben' 
              style = {{width: '500px'}} 
              value = {searchFilter}
              onChange = {(event, data)=>setSearchFilter(data.value)} 
            />
            
            <FormField style={{height: '35px'}}>
              <Button primary circular icon labelPosition='left' onClick={()=>handleFilterClick(backendUrl, searchFilter, pagination, sorting)}><Icon name="filter" /> Filtern</Button>
            </FormField>
          </FormGroup>
        </Form>
        {/*<Max2Media />*/}
      </Segment>
    </>


  );
}

export default Max2PageMedia;
